import React from 'react';
import { RouterConfig } from '../../config/router';
import { UnderOverMenu } from '../../components/UnderOverMenu';

export const allPageTile = [
  {
    title: '19.5',
    over: RouterConfig.FoulOver19,
    under: RouterConfig.FoulUnder19,
  },
  {
    title: '20.5',
    over: RouterConfig.FoulOver20,
    under: RouterConfig.FoulUnder20,
  },
  {
    title: '21.5',
    over: RouterConfig.FoulOver21,
    under: RouterConfig.FoulUnder21,
  },
  {
    title: '22.5',
    over: RouterConfig.FoulOver22,
    under: RouterConfig.FoulUnder22,
  },
  {
    title: '23.5',
    over: RouterConfig.FoulOver23,
    under: RouterConfig.FoulUnder23,
  },
  {
    title: '24.5',
    over: RouterConfig.FoulOver24,
    under: RouterConfig.FoulUnder24,
  },
  {
    title: '25.5',
    over: RouterConfig.FoulOver25,
    under: RouterConfig.FoulUnder25,
  },
  {
    title: '26.5',
    over: RouterConfig.FoulOver26,
    under: RouterConfig.FoulUnder26,
  },
];

export default function UnderOverFouls() {
  return <UnderOverMenu menu={allPageTile} title="Wybór fauli" />;
}
